import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const FormContextHeader = ({ 
  formTitle = 'Untitled Form',
  lastSaved = 'Just now',
  isPublished = false,
  onPreview,
  onEmbed,
  onPublish,
  onSave
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (onSave) {
      setIsSaving(true);
      await onSave();
      setIsSaving(false);
    }
  };

  const handlePreview = () => {
    if (onPreview) {
      onPreview();
    }
  };

  const handleEmbed = () => {
    if (onEmbed) {
      onEmbed();
    }
  };

  const handlePublish = () => {
    if (onPublish) {
      onPublish();
    }
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3">
              <h1 className="text-xl font-heading font-semibold text-foreground truncate">
                {formTitle}
              </h1>
              <div className={`
                flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium
                ${isPublished 
                  ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                }
              `}>
                <Icon 
                  name={isPublished ? 'CheckCircle2' : 'Circle'} 
                  size={14} 
                />
                <span>{isPublished ? 'Published' : 'Draft'}</span>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-1.5 text-sm text-muted-foreground">
              <Icon name="Clock" size={14} />
              <span>Last saved {lastSaved}</span>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <Button
              variant="outline"
              size="default"
              iconName="Eye"
              iconPosition="left"
              onClick={handlePreview}
            >
              Preview
            </Button>

            <Button
              variant="outline"
              size="default"
              iconName="Code2"
              iconPosition="left"
              onClick={handleEmbed}
            >
              Embed
            </Button>

            <Button
              variant="secondary"
              size="default"
              iconName="Save"
              iconPosition="left"
              loading={isSaving}
              onClick={handleSave}
            >
              Save
            </Button>

            <Button
              variant={isPublished ? 'outline' : 'default'}
              size="default"
              iconName={isPublished ? 'RefreshCw' : 'Rocket'}
              iconPosition="left"
              onClick={handlePublish}
            >
              {isPublished ? 'Update' : 'Publish'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormContextHeader;